module.exports = __webpack_public_path__ + "static/media/Punjab Public Library 1938.48ac8280.jpeg";